import { TranslocoService } from '@jsverse/transloco';

import { humanizeKey } from './config-schema.util';

/**
 * A translation for a key built from descriptor codes (e.g. `providers.config.{type}.fields.{key}.label`),
 * or null when there is none — not even in the fallback language — so the caller can fall back to
 * something derived from the code. Checks the loaded translations directly, so absent keys don't
 * trigger Transloco's missing-key warnings.
 */
export function descriptorText(transloco: TranslocoService, key: string): string | null {
  const langs = [transloco.getActiveLang(), transloco.config.fallbackLang].filter(
    (lang): lang is string => typeof lang === 'string',
  );
  const found = langs.some((lang) => key in (transloco.getTranslation(lang) ?? {}));
  return found ? transloco.translate(key) : null;
}

/** A file role's label: `providers.config.{type}.files.roles.{role}`, else the role code made readable. */
export function roleLabel(transloco: TranslocoService, providerType: string | null, role: string): string {
  return (providerType && descriptorText(transloco, `providers.config.${providerType}.files.roles.${role}`)) || humanizeKey(role);
}
